export default __webpack_public_path__ + "static/texture2-732ddbee2db6f209829b7f15904b50a1.png";